import { QK } from 'ck-queries';
import { fetchWithErrorThrowing } from 'ck-utils';
import { useQuery } from '@tanstack/react-query';

interface EventsDivisionsResponse {
  divisions: string[];
}

// Query hook
export const useEventsDivisions = () => {
  return useQuery({
    queryKey: QK.events.divisions,
    queryFn: getEventsDivisions,
  });
};

// Query function
const getEventsDivisions = (): Promise<string[]> =>
  fetchWithErrorThrowing('/events/divisions', {
    method: 'GET',
  })
    .then((res) => res.json())
    .then(({ divisions }: EventsDivisionsResponse) => divisions);
